import { isBettoHistoryTenant } from "@pages/profile-v2/betto/shared/bettoHistoryStyles";
import { BTTO_PROFILE_COLORS } from "@pages/profile-v2/betto/shared/elements";
import styled, { css } from "styled-components";

const NoContentWrapper = styled.div`
	display: flex;
	padding: ${isBettoHistoryTenant ? "32px 16px" : "40px 30px"};
	flex-direction: column;
	align-items: center;
	gap: 10px;
	flex: 1 0 0;
	border-radius: ${isBettoHistoryTenant ? "12px" : "20px"};
	background: ${isBettoHistoryTenant
		? BTTO_PROFILE_COLORS.surface
		: "var(--profile-page-wrapper-bg)"};
	border: ${isBettoHistoryTenant ? `1px solid ${BTTO_PROFILE_COLORS.border}` : "none"};
	min-height: ${isBettoHistoryTenant ? "240px" : "50vh"};

	${({ noBackground }) =>
		noBackground &&
		css`
			background: transparent;
			border: none;
			min-height: auto;
		`}
`;

const NoContentIconWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: ${isBettoHistoryTenant ? "120px" : "auto"};
	height: ${isBettoHistoryTenant ? "120px" : "auto"};

	svg {
		width: 100%;
		height: 100%;
	}
`;

const NoContentTitle = styled.div`
	color: ${isBettoHistoryTenant ? BTTO_PROFILE_COLORS.text : "#fff"};
	text-align: center;
	font-size: ${isBettoHistoryTenant ? "18px" : "24px"};
	font-weight: 600;
	line-height: 1.3;
	letter-spacing: 0.75px;
	padding: 0 10px;
`;

const NoContentDescription = styled.div`
	color: ${isBettoHistoryTenant ? BTTO_PROFILE_COLORS.textMuted : "#fff"};
	text-align: center;
	font-size: 12px;
	font-weight: 400;
	line-height: 20px;
	letter-spacing: 0.3px;
	padding: 0 10px;
`;

export { NoContentDescription, NoContentIconWrapper, NoContentTitle, NoContentWrapper };
